<template>
  <v-col class="text-left">
    <v-btn @click="goBack()" class="ma-4" color="primary" title="page-back" small dark fab>
      <v-icon>mdi-arrow-left-bold</v-icon>
    </v-btn>
  </v-col>
</template>
<script>

export default {
  methods: {
    goBack() {
      this.$router.back();
    }
  }
}

</script>